<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4">
				<div class="row d-flex justify-content-between">
					<div class="col-md-3">
						<h1 class="h3 mb-0 text-gray-800">
							Pedido {{ dados.id }}
						</h1>
					</div>
					<div class="col-md-9 noprint d-flex justify-content-end">
						<button
							class="btn btn-success mr-1"
							@click="gerarPdf">
							<i class="fas fa-file-pdf mr-2"></i>
							Gerar PDF
						</button>
						<button
							class="btn btn-success mr-1"
							v-show="!dados.pago && dados.valor > 0"
							@click="pagar">
							<i class="fas fa-money-check-alt mr-2"></i>
							Efetuar Pagamento
						</button>
						<button
							class="btn btn-success mr-1"
							v-show="!dados.arquivado && dados.entregue"
							@click="arquivar">
							<i class="fas fa-save mr-2"></i>
							Arquivar
						</button>
						<button
							class="btn btn-primary mr-1"
							v-if="dados.arquivado && dados.entregue"
							@click="desarquivar">
							<i class="fas fa-window-restore mr-2"></i>
							Restaurar ao Painel
						</button>
						<pedido-btn-next-estagio
							:dados="dados"
							:key="btnNextEstagioKey"
							@reload="getDados">
						</pedido-btn-next-estagio>
						<button
							class="btn btn-primary mr-1"
							@click="update">
							<i class="fas fa-edit"></i>
						</button>
						<button
							class="btn btn-danger mr-1"
							@click="confirmDestroy()">
							<i class="fas fa-trash"></i>
						</button>
						<button
					        @click="$router.go(-1)"
					        class="btn btn-secondary">
				           	Voltar
				        </button>
				    </div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<!-- Informações -->
					<pedido-info
						:key="pedidoInfoKey"
						:dados="dados"
						@reload="getDados">
					</pedido-info>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<!-- Itens -->
		    		<item-card
		    			:key="btnNextEstagioKey"
		    			@reload="getDados">
		    		</item-card>
				</div>
			</div>
            <div class="row">
				<div class="col-md-12">
					<!-- Pagamentos -->
		    		<pedido-pagamento
                        :key="receitaUpdateKey"
                        :dados="dados"
                        @pagar="pagar()"
                        @reload="getDados">
                    </pedido-pagamento>
				</div>
			</div>
		</div>
		<!-- Editar Pedido -->
		<pedido-update
			@reload="getDados">
		</pedido-update>
		<!-- Efetuar Pagamento -->
		<receita-create
			:pedido="$route.params.id"
			:key="btnNextEstagioKey"
			@reload="getDados()">
		</receita-create>
		<!-- Confirmação para excluir -->
        <bsh-confirm
        	modal_id="confirm_destroy_pedido"
        	:dado_id="$route.params.id"
        	title="Deseja realmente cancelar este pedido?"
        	btn="Excluir"
        	btnStyle="btn-danger"
        	method="delete"
        	:rota="$url+'/api/adm/pedidos/destroy/'"
        	@reload="back()">
        </bsh-confirm>
		<!-- Modal Gerar PDF -->
		<pedido-gerar-pdf></pedido-gerar-pdf>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dados: [],
				btnNextEstagioKey: 1,
                receitaUpdateKey: 2,
				pedidoInfoKey: 3
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/pedidos/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data
	            	this.btnNextEstagioKey++;
                    this.receitaUpdateKey++;
					this.pedidoInfoKey++;
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			gerarPdf(){
				$('#gerar_pdf_pedido').modal('show');
			},
			pagar(){
				$('#create_receita').modal('show');
			},
			arquivar(){
				var config = {
					position: 'bottom-right',
				};
				axios.put(this.$url+'/api/adm/pedidos/arquivar/'+this.$route.params.id)
	            .then(response => {
	            	this.$bshMessage.show(response.data.message, response.data.type, config)
	            	this.getDados()
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			desarquivar(){
				var config = {
					position: 'bottom-right',
				};
				axios.put(this.$url+'/api/adm/pedidos/desarquivar/'+this.$route.params.id)
	            .then(response => {
	            	this.$bshMessage.show(response.data.message, response.data.type, config)
	            	this.getDados()
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			update(){
				$('#update_pedido').modal('show');
			},
			confirmDestroy(){
				$('#confirm_destroy_pedido').modal('show');
			},
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>
